import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Http, Response} from '@angular/http';

@Injectable()
export class ResetPasswordService {
  private API_URL = environment.API_URL;
  private resourceUrl = this.API_URL + '/api/account/reset-password';

  constructor(private http: Http) {}

  reset(email: string) {
    return this.http.post(this.resourceUrl, JSON.stringify(email)).map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/user/recover/reset-password.service.ts